import { getApiBaseUrl } from '@/config/env'

/**
 * Utilidad para resolver URLs de multimedia (imágenes, audios, videos, documentos) en la plataforma.
 * Soporta URLs absolutas externas (http/https), blob/data URLs locales para vista previa inmediata,
 * y rutas relativas almacenadas en el backend (/api/media/..., /storage/... o /api/storage/...),
 * asegurando que se prefijen con VITE_API_URL cuando el frontend y backend corren en dominios o puertos separados.
 */
export function resolveImageUrl(url?: string | null): string {
  if (!url || typeof url !== 'string') return ''
  const trimmed = url.trim()
  if (!trimmed) return ''

  // file:// no es renderizable en el navegador por restricciones de seguridad web
  if (trimmed.startsWith('file://')) return ''

  // URLs ya completas, blob o data-uri
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('blob:') ||
    trimmed.startsWith('data:')
  ) {
    return trimmed
  }

  // Rutas relativas del servidor de almacenamiento o API de medios
  const apiBase = getApiBaseUrl().replace(/\/+$/, '')
  if (trimmed.startsWith('/')) {
    return apiBase ? `${apiBase}${trimmed}` : trimmed
  }

  return apiBase ? `${apiBase}/${trimmed}` : `/${trimmed}`
}

export const resolveMediaUrl = resolveImageUrl
